import Home from "./components/Home/Home";
import Navbar from "./components/Navbar/Navbar";
import Project from "./components/Project/Project";
import Skills from "./components/Skills/Skills";
import Education from "./components/Education/Education";
import Contact from "./components/ContactMe/Contact";
import ToTop from "./components/ToTop/ToTop";

const App = () => {
    return (
      <div className="App">
      <ToTop />
        <Navbar />
        <Home id="home"/>
        <Project id="projects"/>
        <Skills id="skills"/>
        <Education id="edu"/>
        <Contact id="contact"/>
      </div>  
    )
}

export default App;
